import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLanguage } from '../../contexts/LanguageContext';
import './languageSwitcher.scss';

const LanguageSwitcher: React.FC = () => {
  const { t } = useTranslation();
  const { language, changeLanguage } = useLanguage();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  const languages = [
    { code: 'en', name: t('common.english'), flag: '🇺🇸' },
    { code: 'ar', name: t('common.arabic'), flag: '🇸🇦' },
  ];

  const handleLanguageChange = (langCode: string) => {
    changeLanguage(langCode);
    setIsOpen(false);
    // Refresh the page to apply language changes
    setTimeout(() => {
      window.location.reload();
    }, 300);
  };

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const currentLanguage = languages.find(lang => lang.code === language);

  return (
    <div className="language-switcher" ref={dropdownRef}>
      <div className={`dropdown ${isOpen ? 'open' : ''}`}>
        <button
          className="dropdown-toggle"
          type="button"
          onClick={toggleDropdown}
          aria-expanded={isOpen}
          title={t('common.language')}
        >
          <span className="current-language">
            {/* <span className="flag">{currentLanguage?.flag}</span> */}
            <span className="language-text">
              {currentLanguage?.name}
            </span>
          </span>
          <i className={`fa fa-chevron-down ${isOpen ? 'rotated' : ''}`}></i>
        </button>
        <ul className={`dropdown-menu ${isOpen ? 'show' : ''}`}>
          {languages.map((lang) => (
            <li key={lang.code}>
              <button
                className={`dropdown-item ${language === lang.code ? 'active' : ''}`}
                onClick={() => handleLanguageChange(lang.code)}
              >
                {/* <span className="flag">{lang.flag}</span> */}
                <span className="name">{lang.name}</span>
                {language === lang.code && (
                  <i className="fa fa-check check-icon"></i>
                )}
              </button>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default LanguageSwitcher;
